<!-- <div class="header-title" [ngClass]="color || colorDefault">
    {{title || 'Sin titulo'}}
</div> -->
<div class="header" [style]="style">
    <div class="content" [style]="style" [ngClass]="'greendAnalityco' || 'primary'">{{title || 'Sin titulo'}}</div>
</div>